import * as React from 'react';
import { SubscriptionsPanelProps } from './types';
import { hasOptionsValues } from './selectors';
import { SubscriptionsContainer } from 'app/area/user-profile/subscriptions/subscriptions-panel/subscriptions-container';

export const SubscriptionsPanel: React.FC<SubscriptionsPanelProps> = (props) => {

  const { subscribedText, subscriptions, optionsCodes, formName, locale, validation, translation, saveSubscriptions } = props;
  const hasValues = props.optionsCodes?.values?.length > 0 || hasOptionsValues(subscriptions);

  return hasValues ? <SubscriptionsContainer
    subscribedText={subscribedText}
    optionsCodes={optionsCodes}
    valueItems={subscriptions}
    translation={translation}
    locale={locale}
    validation={validation?.[formName]}
    onChange={saveSubscriptions}
  /> : null;
};
